import country from "./country.json";
import nationalities from "./nationalities.json";

export const rules = [{ required: false, message: "This field is required" }];

export const validateConfirmPassword = ({ getFieldValue }) => ({
  validator(_, value) {
    if (!value || getFieldValue("password") === value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Password must be same"));
  },
});

export const validatePassword = () => ({
  validator(_, value) {
    if (
      !value ||
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/.test(value)
    ) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(
        "Use at least one lowercase, uppercase, number, and special character"
      )
    );
  },
});

export const validatePhoneNumber = (_, value) => {
  const reg = /^[0-9]+$/; // Regular expression for numbers
  if (!value || reg.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Phone number must be numeric"));
};

//
const languages = [
  { label: "English", key: "English" },
  { label: "Arabic", key: "Arabic" },
  { label: "Chinese", key: "Chinese" },
  { label: "French", key: "French" },
  { label: "German", key: "German" },
  { label: "Spanish", key: "Spanish" },
  { label: "Japanese", key: "Japanese" },
  { label: "Korean", key: "Korean" },
  { label: "Russian", key: "Russian" },
  { label: "Italian", key: "Italian" },
  { label: "Portuguese", key: "Portuguese" },
  { label: "Hindi", key: "Hindi" },
  { label: "Bengali", key: "Bengali" },
  { label: "Dutch", key: "Dutch" },
  { label: "Swedish", key: "Swedish" },
  { label: "Turkish", key: "Turkish" },
  { label: "Greek", key: "Greek" },
  { label: "Hebrew", key: "Hebrew" },
  { label: "Polish", key: "Polish" },
  { label: "Czech", key: "Polish" },
];

export const SOFT_SKILLS = [
  { Id: 1, Name: "Leadership" },
  { Id: 2, Name: "Critical Thinking" },
  { Id: 3, Name: "Problem Solving" },
  { Id: 4, Name: "Public Speaking" },
  { Id: 5, Name: "Professional Writing" },
  { Id: 6, Name: "Team Work" },
  { Id: 7, Name: "Digital Literacy" },
  { Id: 8, Name: "Stress Management" },
  { Id: 9, Name: "Communication" },
];

export const SIGNUP_FORM_BASIC = {
  BUGS_UPDATED_MODAL: [
    [
      {
        id: 1,
        name: "Title",
        label: "Title",
        placeholder: "Title",
        rules: [{ required: true, message: "Title is required" }],
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 2,
        name: "Description",
        label: "Description",
        placeholder: "Description",
        rules: [
          ...rules,
          // { required: true, message: "Description is required" },
        ],
        type: "TextArea",
        className: "w-full",
      },
      {
        id: 3,
        name: "ImageUrl",
        label: "Upload Image",
        placeholder: "Upload Screenshot etc.",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "Upload",
        showUploadList: false,
        className: "w-full",
      },
      {
        id: 4,
        name: "Type",
        placeholder: "Bug Types",
        label: "Bug Types",
        rules,
        type: "Dropdown",
        items: [
          { key: "Functionality Feedback", label: "Functionality Feedback" },
          { key: "Technical Support", label: "Technical Support" },
          { key: "Design Feedback", label: "Design Feedback" },
          { key: "Critical Issues", label: "Critical Issues" },
          { key: "reporting", label: "Reporting" },
          { key: "Suggestion", label: "Suggestion" },
          { key: "Others", label: "Others" },
        ],
        className: "w-full",
      },
    ],
  ],
  "Basic Information": [
    // {
    //   id: 1,
    //   name: "fname",
    //   label: "First Name",
    //   placeholder: "Enter First Name",
    //   rules,
    //   type: "TextInput",
    // },
    // {
    //   id: 2,
    //   name: "lname",
    //   label: "Last Name",
    //   placeholder: "Enter Last Name",
    //   rules,
    //   type: "TextInput",
    // },
    {
      id: 2,
      name: "Name",
      label: "Full Name",
      placeholder: "e.g: Ali Al-Nisar",
      rules: [
        ...rules,
        {
          pattern: /^.{5,}$/,
          message: "Full Name value should be minimum 5",
        },
      ],
      type: "TextInput",
    },
    {
      id: 1,
      name: "PreferredName",
      label: "Preferred Name",
      placeholder: "Preferred Name",
      rules,
      type: "TextInput",
    },
    {
      id: 4,
      name: "Email",
      label: "Email",
      placeholder: "e.g: ali@mawhiba.com",
      rules: [...rules, { type: "email", message: "Please enter valid Email" }],
      type: "Email",
      // disabled: true,
    },
    {
      id: 6,
      name: "Gender",
      label: "Gender",
      placeholder: "e.g: Male",
      rules,
      type: "Dropdown",
      items: [
        { key: "Male", label: "Male" },
        { key: "Female", label: "Female" },
        { key: "Not Specified", label: "Not Specified" },
      ],
    },
    {
      id: 3,
      name: "Phone",
      label: "Phone",
      placeholder: "Enter Phone No.",
      rules: [
        ...rules,
        {
          pattern: /^\+?(\d{1,3})?[-.\s]?(\d{3})[-.\s]?(\d{3})[-.\s]?(\d{4})$/,
          message: "Please enter a valid phone number!",
        },
      ],
      type: "PhoneInput",
      // disabled: true,
    },
    {
      id: 10,
      name: "CountryOfResidency",
      label: "Country of Residency",
      placeholder: "Country of Residency",
      rules,
      type: "Select",
      options: country.map((country) => ({
        label: country.label,
        value: country.label,
      })),
    },
    // {
    //   id: 11,
    //   name: "Address1",
    //   label: "Address One",
    //   placeholder: "Enter Your Address",
    //   rules,
    //   // type: "TextArea",
    //   type: "TextInput",
    //   className: "md:w-full",
    // },
    // {
    //   id: 19,
    //   name: "Address2",
    //   label: "Address Two",
    //   placeholder: "Enter Your Address",
    //   rules,
    //   // type: "TextArea",
    //   type: "TextInput",
    //   className: "md:w-full",
    // },
    // {
    //   id: 20,
    //   name: "Institution",
    //   label: "Institution",
    //   placeholder: "Enter Your Institution Name",
    //   rules,
    //   // type: "TextArea",
    //   type: "TextInput",
    //   className: "md:w-full",
    // },
    {
      id: 21,
      name: "Nationality",
      label: "Nationality",
      placeholder: "Enter Your Nationality",
      rules: [
        ...rules,
        {
          pattern: /^[a-zA-Z]+$/,
          message: "Please enter a valid input value!",
        },
      ],
      type: "Select",
      options: nationalities.map((country) => ({
        label: country,
        value: country,
      })),
      className: "md:w-full",
    },
    {
      id: 22,
      name: "Passports",
      label: "Evidence of Nationality (Passport)",
      placeholder: "Upload Your Passport",
      rules, // [{ required: true, message: "Please upload your document!" }],
      type: "Upload", // Custom type to identify this as an upload field in your rendering logic
      accept: ".pdf,.doc,.docx", // Accepts PDF and Word documents; adjust as needed
      action: "", // The URL to upload the document to - set this according to your backend API
      maxCount: 1, // Allows only a single file to be uploaded
      listType: "text", // Style of the file list, adjust as needed (e.g., "text", "picture")
      // Additional propert
      className: "md:w-full",
    },
    {
      id: 23,
      name: "Resume",
      label: "Resume",
      placeholder: "Upload Your Resume",
      rules, // [{ required: true, message: "Please upload your document!" }]
      type: "Upload", // Custom type to identify this as an upload field in your rendering logic
      accept: ".pdf,.doc,.docx", // Accepts PDF and Word documents; adjust as needed
      action: "", // The URL to upload the document to - set this according to your backend API
      maxCount: 1, // Allows only a single file to be uploaded
      listType: "text", // Style of the file list, adjust as needed (e.g., "text", "picture")
      // Additional propert
      className: "md:w-full",
    },
    {
      id: 26,
      name: "LettersOfRecommendations",
      label: "Letters of Recommendations",
      placeholder: "Letters of Recommendations",
      rules, // [{ required: true, message: "Please upload your document!" }]
      type: "Upload", // Custom type to identify this as an upload field in your rendering logic
      accept: ".pdf,.doc,.docx", // Accepts PDF and Word documents; adjust as needed
      action: "", // The URL to upload the document to - set this according to your backend API
      maxCount: 1, // Allows only a single file to be uploaded
      listType: "text", // Style of the file list, adjust as needed (e.g., "text", "picture")
      // Additional propert
      className: "md:w-full",
    },
    {
      id: 5,
      name: "DOB",
      label: "Date of birth",
      placeholder: "Select Date of birth",
      rules,
      type: "Date",
    },
    // {
    //   id: 14,
    //   name: "Language",
    //   placeholder: "Select Language",
    //   label: "Language",
    //   rules: rules,
    //   // type: "Dropdown",
    //   // items: languages,
    //   type: "Select",
    //   options: languages.map((lang) => ({ ...lang, value: lang.key })),
    // },
    {
      id: 17,
      name: "Country",
      label: "Country",
      placeholder: "Select Country",
      rules: rules,
      // type: "Dropdown",
      // items: country.slice(0, 10).map((country) => ({
      //   label: country.label,
      //   key: country.key,
      // })),
      type: "Select",
      options: country.map((country) => ({
        label: country.label,
        value: country.label,
      })),
    },
    {
      id: 18,
      name: "City",
      placeholder: "Select City",
      label: "City",
      rules: rules,
      // type: "Dropdown", // Changed from TextInput to Dropdown
      // items: [], // Initially empty, will be filled based on country selection
      type: "Select",
      options: [],
    },
    {
      id: 23,
      name: "State",
      label: "Region/State/Province",
      placeholder: "Region/State/Province",
      rules,
      type: "TextInput",
      // disabled: true,
    },
    {
      id: 9,
      name: "PersonalStatement",
      label: "Personal Statement",
      placeholder: "Personal Statement",
      rules,
      type: "TextInput",
      // disabled: true,
    },
    {
      id: 24,
      name: "References",
      label: "References",
      placeholder: "References",
      rules,
      type: "TextInput",
      // disabled: true,
    },
    {
      id: 25,
      name: "areaOfExpertise ",
      label: "Area of Expertise ",
      placeholder: "Area of Expertise ",
      rules,
      type: "TextInput",
      // disabled: true,
    },
    {
      id: 26,
      name: "IntrestedTrack",
      placeholder: "Select Interested Track ",
      label: "Interested Track",
      rules: rules,
      variant: "filled",
      mode: "multiple",
      // type: "Dropdown", // Changed from TextInput to Dropdown
      // items: [], // Initially empty, will be filled based on country selection
      type: "Select",
      options: [
        {
          label: "Leadership",
          value: "Leadership",
        },
        {
          label: "Research and Development",
          value: "Research and Development",
        },
        {
          label: "Entrepreneurship",
          value: "Entrepreneurship",
        },
        {
          label: "Professional in STEM field",
          value: "Professional in STEM field",
        },
        {
          label: "Data Science Specialist",
          value: "Data Science Specialist",
        },
      ],
    },
    // {
    //   id: 12,
    //   name: "Working",
    //   rules,
    //   type: "Checkbox",
    //   data: [
    //     { label: "I'm currently studying", value: "studying" },
    //     { label: "I'm currently working", value: "working" },
    //   ],
    //   className: "md:w-full flex gap-x-10",
    //   isShowLoginLink: true,
    // },
  ],
  "Education Information": [
    [
      {
        id: 1,
        name: "InstituteName",
        label: "Institute Name",
        placeholder: "Institute Name",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 10,
        name: "Country",
        label: "Country of Institute",
        placeholder: "Country of Institute",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "Select",
        options: country.map((country) => ({
          label: country.label,
          value: country.label,
        })),
        className: "w-full",
      },
      {
        id: 11,
        name: "City",
        label: "City of Institute",
        placeholder: "City of Institute",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "Select",
        options: [],
        className: "w-full",
      },
      {
        id: 2,
        name: "QualificationType",
        label: "Qualification Type",
        placeholder: "Qualification Type",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "Dropdown",
        items: [
          { key: "Intermediate", label: "Intermediate" },
          { key: "Graduate", label: "Graduate" },
          { key: "Post Graduate", label: "Post Graduate" },
        ],
        className: "w-full",
      },
      {
        id: 6,
        name: "DegreeTypes",
        label: "Degree Types",
        placeholder: "Type Of Degree",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "Dropdown",
        items: [
          { key: "High School", label: "High School" },
          { key: "Bachelors Degree", label: "Bachelors Degree" },
          { key: "Masters Degree", label: "Masters Degree" },
          { key: "Doctorate Degree", label: "Doctorate Degree" },
          { key: "Post Doctorate Degree", label: "Post Doctorate Degree" },
          { key: "Professional Degree", label: "Professional Degree" },
          { key: "Vocational Diploma", label: "Vocational Diploma" },
          { key: "Certification", label: "Certification" },
          { key: "Postgraduate Degree", label: "Postgraduate Degree" },
        ],
        className: "w-full",
      },
      {
        id: 7,
        name: "Grade",
        label: "Grade",
        placeholder: "Grade",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 3,
        name: "ProgramName",
        label: "Program Name",
        placeholder: "Program Name",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 4,
        name: "Year",
        label: "Year",
        placeholder: "Program Year",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 5,
        name: "Major",
        label: "Major",
        placeholder: "Enter Your Major",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "TextInput",
        className: "w-full",
      },
      // {
      //   id: 17,
      //   name: "Country",
      //   label: "Country",
      //   placeholder: "Select Country",
      //   // type: "Dropdown",
      //   // items: country.slice(0, 10).map((country) => ({
      //   //   label: country.label,
      //   //   key: country.key,
      //   // })),
      //   type: "Select",
      //   options: country.map((country) => ({
      //     label: country.label,
      //     value: country.label,
      //   })),
      // },
      // {
      //   id: 18,
      //   name: "City",
      //   placeholder: "Select City",
      //   label: "City",
      //   // type: "Dropdown", // Changed from TextInput to Dropdown
      //   // items: [], // Initially empty, will be filled based on country selection
      //   type: "Select",
      //   options: [],
      // },
      {
        id: 56,
        name: "Certificate",
        label: "Upload Degree/Certificate",
        placeholder: "File certificate .PDF",
        rules,
        type: "Upload",
        className: "w-full",
        maxCount: 10,
        multiple: true,
      },
      {
        id: 9,
        name: "Transcript",
        label: "Upload Transcript field",
        placeholder: "Upload Transcript field",
        rules,
        type: "Upload",
        className: "w-full",
        maxCount: 10,
        multiple: true,
      },
      {
        id: 8,
        name: "Description",
        label: "Description ",
        placeholder: "Description ",
        rules: [...rules, { required: true, message: "This field is required" }],
        type: "TextArea",
        className: "w-full",
      },
      {
        id: 489,
        name: "CurrentlyStudy",
        rules,
        type: "Checkbox",
        data: [{ label: "I'm currently studying here", value: true }],
      },
    ],
  ],
  "Professional Experience": [
    [
      {
        id: 1,
        name: "Title",
        placeholder: "Title",
        label: "Title",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 2,
        name: "EmployementType",
        placeholder: "Employment Type",
        label: "Employment Type",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "Dropdown",
        items: [
          { key: "Contract", label: "Contract" },
          { key: "Full-time", label: "Full-time" },
          { key: "Part-time", label: "Part-time" },
          { key: "Self-employed", label: "Self-employed" },
          { key: "Freelance", label: "Freelance" },
          { key: "Internship", label: "Internship" },
          { key: "Apprenticeship", label: "Apprenticeship" },
        ],
        className: "w-full",
      },
      {
        id: 3,
        name: "CompanyName",
        placeholder: "Company Name",
        label: "Company Name",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "TextInput",
        className: "w-full",
      },
      // {
      //   id: 17,
      //   name: "Country",
      //   label: "Country",
      //   placeholder: "Select Country",
      //   rules: rules,
      //   // type: "Dropdown",
      //   // items: country.slice(0, 10).map((country) => ({
      //   //   label: country.label,
      //   //   key: country.key,
      //   // })),
      //   type: "Select",
      //   options: country.map((country) => ({
      //     label: country.label,
      //     value: country.label,
      //   })),
      // },
      // {
      //   id: 18,
      //   name: "City",
      //   placeholder: "Select City",
      //   label: "City",
      //   rules: rules,
      //   // type: "Dropdown", // Changed from TextInput to Dropdown
      //   // items: [], // Initially empty, will be filled based on country selection
      //   type: "Select",
      //   options: [],
      // },
      {
        id: 5,
        name: "StartDate",
        label: "Start Date",
        placeholder: "Start Date",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "Date",
        className: "md:w-full",
      },
      {
        id: 6,
        name: "EndDate",
        label: "End Date",
        placeholder: "End Date",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "Date",
        className: "md:w-full",
      },
      {
        id: 7,
        name: "Location",
        label: "Location",
        placeholder: "e.g. London, United Kingdom",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "TextInput",
        className: "md:w-full",
      },
      {
        id: 10,
        name: "Industry",
        label: "Industry",
        placeholder: "Industry",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "TextInput",
        className: "md:w-full",
      },
      {
        id: 8,
        name: "LocationType",
        placeholder: "Location Type ",
        label: "Location Type ",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "Dropdown",
        items: [
          { key: "On-site", label: "On-site" },
          { key: "Hybrid", label: "Hybrid" },
          { key: "Remote", label: "Remote" },
        ],
        className: "w-full",
      },
      {
        id: 56,
        name: "Certificate",
        label: "Evidence of Employment",
        placeholder: "File certificate .PDF",
        rules,
        type: "Upload",
        className: "w-full",
        maxCount: 1,
        // listType: "picture-card",
      },
      {
        id: 9,
        name: "Description",
        label: "Description",
        placeholder: "Description",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "TextArea",
        className: "w-full",
        // maxCount: 1,
        // listType: "picture-card",
      },
      {
        id: 489,
        name: "CurrentlyWorking",
        rules,
        type: "Checkbox",
        data: [
          { label: "I'm currently working in this role", value: "working" },
        ],
      },
    ],
  ],
  Publications: [
    [
      {
        id: 1,
        name: "Title",
        placeholder: "Title",
        label: "Title",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 2,
        name: "Publication/Publisher",
        placeholder: "Publication/Publisher",
        label: "Publication/Publisher",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 3,
        name: "Publication date",
        placeholder: "Publication date",
        label: "Publication date",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "Date",
        className: "w-full",
      },
      {
        id: 4,
        name: "Authors",
        placeholder: "Authors",
        label: "Authors",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        mode: "tags",
        type: "Select",
        className: "w-full",
      },
      {
        id: 5,
        name: "Publication URL",
        placeholder: "Publication URL",
        label: "Publication URL",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 7,
        name: "Description",
        placeholder: "Description",
        label: "Description",
        rules: [
          ...rules,
          { required: true, message: "This field is required" },
        ],
        type: "TextArea",
        className: "w-full",
      },
    ],
  ],
  AchievementsInformation: [
    [
      {
        id: 1,
        name: "Name",
        placeholder: "Name",
        label: "Name",
        rules,
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 2,
        name: "Rank",
        placeholder: "Rank",
        label: "Rank",
        rules,
        type: "TextInput",
        className: "w-full",
      },
      // {
      //   id: 3,
      //   name: "Type",
      //   placeholder: "Type",
      //   label: "Type",
      //   rules,
      //   type: "TextInput",
      //   className: "w-full",
      // },
      // {
      //   id: 4,
      //   name: "NationalityStatus",
      //   placeholder: "Nationality Status",
      //   label: "Nationality Status",
      //   rules,
      //   type: "TextInput",
      //   className: "w-full",
      // },
      {
        id: 5,
        name: "Country",
        label: "Country",
        placeholder: "Select Country",
        rules: rules,
        type: "Select",
        options: country.map((country) => ({
          label: country.label,
          value: country.label,
        })),
      },
      {
        id: 6,
        name: "Date",
        placeholder: "Date",
        label: "Date",
        rules,
        type: "Date",
        className: "w-full",
      },
      {
        id: 7,
        name: "Description",
        placeholder: "Description",
        label: "Description",
        rules,
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 8,
        name: "Attachments",
        placeholder: "Attachments",
        label: "Attachments",
        rules,
        type: "Upload",
        accept: "*",
        className: "w-full",
      },
    ],
  ],
  SoftSkills: [
    [
      // {
      //   id: 1,
      //   name: "Name",
      //   placeholder: "Skill",
      //   label: "Skill",
      //   rules,
      //   type: "TextInput",
      //   className: "w-full",
      // },
      {
        id: 14,
        name: "Name",
        placeholder: "Skill",
        label: "Skill",
        rules: rules,
        type: "Select",
        options: SOFT_SKILLS.map(({ Name }) => ({ label: Name, value: Name })),
      },
      {
        id: 2,
        name: "Description",
        placeholder: "Description",
        label: "Description",
        rules,
        type: "TextInput",
        className: "w-full",
      },
    ],
  ],
  ExtraCurricularActivities: [
    [
      {
        id: 1,
        name: "Name",
        placeholder: "Write Activity Title",
        label: "Activity",
        rules,
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 2,
        name: "Description",
        placeholder: "Description",
        label: "Description",
        rules,
        type: "TextInput",
        className: "w-full",
      },
      // {
      //   id: 2,
      //   name: "Community Building",
      //   placeholder: "Community Building",
      //   label: "Community Building",
      //   rules,
      //   type: "TextInput",
      //   className: "w-full",
      // },
      // {
      //   id: 3,
      //   name: "Tennis",
      //   placeholder: "Tennis",
      //   label: "Tennis",
      //   rules,
      //   type: "TextInput",
      //   className: "w-full",
      // },
      // {
      //   id: 4,
      //   name: "Karting",
      //   placeholder: "Karting",
      //   label: "Karting",
      //   rules,
      //   type: "TextInput",
      //   className: "w-full",
      // },
    ],
  ],
  SpecialTalent: [
    [
      {
        id: 1,
        name: "Name",
        placeholder: "Special Talent",
        label: "Enter Special Talent Name",
        rules,
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 2,
        name: "Description",
        placeholder: "Description",
        label: "Description",
        rules,
        type: "TextInput",
        className: "w-full",
      },
      {
        id: 3,
        name: "Attachments",
        label: "Attach Proof of Talent",
        placeholder: "Upload your file here",
        rules, // [{ required: true, message: "Please upload your document!" }],
        type: "Upload", // Custom type to identify this as an upload field in your rendering logic
        accept: "*", // Accepts PDF and Word documents; adjust as needed
        action: "", // The URL to upload the document to - set this according to your backend API
        maxCount: 1, // Allows only a single file to be uploaded
        listType: "text", // Style of the file list, adjust as needed (e.g., "text", "picture")
        // Additional propert
        className: "md:w-full",
      },
    ],
  ],
  PsychologicalChallenges: [
    [
      {
        id: 1,
        name: "Name",
        placeholder: "Enter Psychological Challenge",
        label: "Psychological Challenge You have faced",
        rules,
        type: "TextInput",
        className: "w-full",
      },
    ],
  ],
  SocialChallenges: [
    [
      {
        id: 1,
        name: "Name",
        placeholder: "Enter Social Challenge",
        label: "Social Challenge you have faced",
        rules,
        type: "TextInput",
        className: "w-full",
      },
    ],
  ],
};

export const PHONE_PREFIX = [
  "+86",
  "+87",
  "+966",
  "+971",
  "+92",
  "+91",
  "+98",
  "+20",
];
